import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const CheckboxInput = ({ label, ...props }) => {
  return <FormControlLabel control={<Checkbox {...props} />} label={label} />;
};

export default CheckboxInput;
